export const dummyRows = [
  {
    swot: "S",
    pestle: "P",
    internalIssues: "Internal Strength",
    externalIssues: "External Opportunity",
    businessStrategy: "Growth Strategy",
    competitorAnalysis: "Competitor A Analysis",
  },
  {
    swot: "W",
    pestle: "E",
    internalIssues: "Internal Weakness",
    externalIssues: "External Threat",
    businessStrategy: "Cost Reduction",
    competitorAnalysis: "Competitor B Analysis",
  },
  {
    swot: "O",
    pestle: "S",
    internalIssues: "Internal Opportunity",
    externalIssues: "External Strength",
    businessStrategy: "Market Expansion",
    competitorAnalysis: "Competitor C Analysis",
  },
  {
    swot: "T",
    pestle: "T",
    internalIssues: "Internal Threat",
    externalIssues: "External Weakness",
    businessStrategy: "Risk Mitigation",
    competitorAnalysis: "Competitor D Analysis",
  },
  {
    swot: "",
    pestle: "L",
    internalIssues: "Internal Legal Issue",
    externalIssues: "External Legal Opportunity",
    businessStrategy: "Compliance Strategy",
    competitorAnalysis: "Competitor E Analysis",
  },
  {
    swot: "",
    pestle: "E",
    internalIssues: "Internal Environmental Issue",
    externalIssues: "External Environmental Opportunity",
    businessStrategy: "Sustainability Strategy",
    competitorAnalysis: "Competitor F Analysis",
  },
  {
    swot: "",
    pestle: "",
    internalIssues: "",
    externalIssues: "",
    businessStrategy: "",
    competitorAnalysis: "",
  },
];

export const dummyLogs = [
  { date: "2023-10-01", user: "Admin", action: "Created entry" },
  { date: "2023-10-02", user: "Editor", action: "Updated SWOT analysis" },
  { date: "2023-10-03", user: "Viewer", action: "Viewed logs" },
];
